// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__QuzT4","title":"card_title__Kr6K_","inActive":"card_inActive__1S3HV"};